export const DOUBLE_WIDTH = 16.5;
export const DOUBLE_DEPTH = 82.4375;

export const VERTICAL_WIDTH = 24.5;
export const VERTICAL_DEPTH = 40.875;

export const VARSITY_WIDTH = 38;
export const VARSITY_DEPTH = 77.8125;



// WEBPACK FOOTER //
// ./src/components/App/configurator.js